import React from 'react';
import './RutaCargando.css';

/**
 * Red de seguridad del code splitting (P4).
 *
 * Si el navegador no puede descargar el chunk de una ruta diferida —red caída,
 * o un deploy nuevo que dejó huérfano el hash del chunk viejo cacheado—,
 * React.lazy lanza y, sin un error boundary, el árbol entero se desmonta:
 * pantalla en blanco en TODA la app, no solo en la ruta.
 *
 * Este boundary contiene la falla dentro del área de contenido, la dice en
 * pantalla (S2: los errores llegan al usuario, no solo a la consola) y ofrece
 * recargar, que es lo único que resuelve un chunk huérfano.
 *
 * Se remonta con `key={pathname}` desde AppLayout, así una ruta rota no deja
 * bloqueada la navegación al resto del sitio.
 */
class ErrorDeCarga extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fallo: false };
  }

  static getDerivedStateFromError() {
    return { fallo: true };
  }

  componentDidCatch(error, info) {
    console.error('[rutas] no se pudo cargar la sección', error, info);
  }

  render() {
    if (!this.state.fallo) return this.props.children;

    return (
      <div className="rc-error" role="alert">
        <h2 className="rc-error__titulo">No se pudo cargar esta sección</h2>
        <p className="rc-error__detalle">
          Puede ser un problema momentáneo de conexión. Si el sitio se actualizó
          hace poco, recargar la página resuelve el error.
        </p>
        <button
          type="button"
          className="rc-error__boton"
          onClick={() => window.location.reload()}
        >
          Recargar la página
        </button>
      </div>
    );
  }
}

export default ErrorDeCarga;
